
import { ref } from "vue";
import TabBox from "./TabBox.vue";
export default {
  name: "TradeDialog",
  components: {
    TabBox
  },
  setup() {
    const Dialog = ref();
    const targetId = ref(-1);
    const close = () => {
      Dialog.value.close();
    };
    const open = (id: number) => {
      targetId.value = id;
      Dialog.value.open();
    };
    return {
      Dialog,
      close,
      open,
      targetId
    };
  }
};
